import { render, staticRenderFns } from "./COrganizeCrime.vue?vue&type=template&id=5051c985"
import script from "./COrganizeCrime.vue?vue&type=script&lang=js"
export * from "./COrganizeCrime.vue?vue&type=script&lang=js"
import style0 from "./COrganizeCrime.vue?vue&type=style&index=0&id=5051c985&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports